import React, { Component } from "react";
import ParticlesBg from "particles-bg";
import Fade from "react-reveal";

class Header extends Component {
  render() {
    if (!this.props.data) return null;

    const project = this.props.data.project;
    const github = this.props.data.github;
    const name = this.props.data.name;
    const description = this.props.data.description;

    return (
      <header id="home">
        <ParticlesBg type="circle" bg={true} />

        <nav id="nav-wrap">
          <a className="mobile-btn" href="#nav-wrap" title="Show navigation">
            Show navigation
          </a>
          <a className="mobile-btn" href="#home" title="Hide navigation">
            隐藏导航
          </a>

          <ul id="nav" className="nav">
            <li className="current">
              <a className="smoothscroll" href="#home">
                主页
              </a>
            </li>

            <li>
              <a className="smoothscroll" href="#about">
                关于
              </a>
            </li>

            <li>
              <a className="smoothscroll" href="#resume">
                简历
              </a>
            </li>

            <li>
              <a className="smoothscroll" href="#portfolio">
                项目
              </a>
            </li>

            <li>
              <a className="smoothscroll" href="#contact">
                联系
              </a>
            </li>
          </ul>
        </nav>

        <div className="row banner">
          <div className="banner-text">
            <Fade bottom>
              <h1 className="responsive-headline">{name}</h1>
            </Fade>
            <Fade bottom duration={1200}>
              <h3>{description}</h3>
            </Fade>
            <hr />
            <Fade bottom duration={2000}>
            <ul>
              <li className="social" >
                <a href={project} className="button btn project-btn;" role="button" aria-disabled="true">
                  <i className="fa fa-book"></i>博客
                </a>
                <a href={github} className="button btn github-btn" role="button" aria-disabled="true">
                  <i className="fa fa-github"></i>Github
                </a>
              </li>
            </ul>
            </Fade>
          </div>
        </div>

        <p className="scrolldown">
          <a className="smoothscroll" href="#about">
            <i className="icon-down-circle"></i>
          </a>
        </p>
      </header>
    );
  }
}

export default Header;
